import React from "react"


type Props = {
  src: string
  videoClass: string
}

const Video: React.FC<Props> = (props) => (
  <div className="flex justify-center items-center">
    <video controls autoPlay muted loop className={props.videoClass}>
      <source src={props.src} type="video/mp4" />
    </video>
  </div>
)
export default Video